import React, { useEffect, useRef } from 'react'
import { useContext } from 'react'
import { LocaleContext } from '../../routes'
import { Notification } from '../../styles/elements'
import { NotificationClose } from '../../styles/image'

export default ({ type, text, icon, opacity, timeError }) => {
  const locale = useContext(LocaleContext)
  const notification = useRef()

  const hide = () => {
    notification.current && (notification.current.style.opacity = 0)
  }

  useEffect(() => {
    notification.current && (notification.current.style.opacity = (opacity || 0.95))
    const timer = setTimeout(() => {
      notification.current && (notification.current.style.opacity = 0)
    }, (timeError || 7500))

    return () => clearTimeout(timer)
  })

  return (
    <Notification
      className={type}
      ref={notification}
      isShown
    >
      <NotificationClose
        src={icon || require(`../../assets/icons/${type}.svg`)}
        alt=""
        isBright
        onClick={hide}
      />
      <span>{text || locale[`${type.toUpperCase()}_MESSAGE`]}.</span>
    </Notification>
  )
}